export function suppressNonErrorConsole() {
  console.log = () => undefined
  console.info = () => undefined
  console.warn = () => undefined
  console.debug = () => undefined
}
